import React, {useEffect} from "react";
import InfoItem from "../InfoItem/InfoItem";
import {checkEmptyObj, moveElementToEnd} from "helper/common";
import ArrayLabel from "../ArrayLabel/ArrayLabel";
import {Divider, Space} from "antd";

const Cornea = props => {
  const {data, isShow = true} = props;
  useEffect(() => {}, []);
  const render = () => {
    return (
      <>
        {isShow && <div className="title">Giác mạc:</div>}
        <Space direction="vertical">
          {moveElementToEnd(
            Object.keys(data || {}).filter(
              key =>
                data[key] &&
                key != "show" &&
                key != "Option" &&
                key != "Test Schirmer 2Inside" &&
                key != "Test Schirmer 1Inside"
            ),
            "Ghi chú"
          ).map(key => {
            if (key == "Bề mặt") {
              return <ArrayLabel data={data[key]} name={key}></ArrayLabel>;
            } else if (key == "FormList") {
              return (
                <>
                  {data[key].map((e, index) => {
                    if (e?.input1) {
                      return (
                        <div>
                          {" "}
                          <span> • CCT {index + 1}</span>:{" "}
                          <span>{e?.input1} μm</span> lúc{" "}
                          <span>{e?.input2}</span>{" "}
                        </div>
                      );
                    }
                  })}
                </>
              );
            } else if (key == "Test Schirmer 1") {
              return (
                <div>
                  {" "}
                  <span>
                    <InfoItem label={key} value={data[key]} />
                  </span>{" "}
                  <span>trong </span>
                  <span>{data["Test Schirmer 1Inside"]} phút</span>
                </div>
              );
            } else if (key == "Test Schirmer 2") {
              return (
                <div>
                  {" "}
                  <span>
                    <InfoItem label={key} value={data[key]} />
                  </span>{" "}
                  <span>trong </span>
                  <span>{data["Test Schirmer 2Inside"]} phút</span>
                </div>
              );
            } else {
              return <InfoItem label={key} value={data[key]} />;
            }
          })}
        </Space>
        <Divider className="border-grey"></Divider>
      </>
    );
  };
  return <div className="cornea">{!checkEmptyObj(data) && render()}</div>;
};
export default Cornea;
